import React from 'react';
import FaiBox from "../../../../MuiComponents/FaiBox";
import {Card as MuiCard, Grid} from "@mui/material";
import FaiTypography from "../../../../MuiComponents/FaiTypography";
import theme from "../../../../assets/theme";


type CardProps = {
    data?: any;
    children?: React.ReactNode;
    bgColor: string;
    icon: any;
    title: string;
    footer: any;
    amount?: string | number;
};


function Card(props: CardProps) {
    const {typography, borders} = theme;
    const {borderRadius} = borders
    const {bgColor, icon, title, footer, amount} = props;
    
    // Format the amount if it exists, otherwise use a default
    const displayAmount = amount !== undefined ? 
        (typeof amount === 'number' ? `₹${amount.toLocaleString()}` : amount) : 
        null;
    
    return (
        <>
            <MuiCard sx={{
                borderRadius: borderRadius.md,
                minWidth: "347px",
                height: "116px",
                backgroundColor: bgColor
            }}>
                <FaiBox p={"16px"}>
                    <FaiBox>
                        <Grid container alignItems="center">
                            <Grid item xs={8}>
                                <FaiBox ml={2} lineHeight={1}>
                                    <FaiBox color={"white"}>
                                        <FaiTypography variant="caption" color={"inherit"}>
                                            {title}
                                        </FaiTypography>
                                    </FaiBox>
                                    <FaiBox>
                                        <FaiTypography variant={"h4"} fontWeight={typography.fontWeightBold}
                                                       color={"white"}>
                                            {displayAmount || '₹0'}
                                        </FaiTypography>
                                    </FaiBox>
                                    <FaiBox color={"white"}>
                                        {footer}
                                    </FaiBox>
                                </FaiBox>
                            </Grid>
                            <Grid item color={"white"} xs={4}>
                                <FaiBox display="flex"
                                        justifyContent="flex-end"
                                        alignItems="center">
                                    <FaiBox
                                        width="3rem"
                                        height="3rem"
                                        borderRadius="section"
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        p={"27px"}
                                        border={"2.8px solid white"}
                                    >
                                        <FaiBox component={"img"} src={icon} height="29px"/>
                                    </FaiBox>
                                </FaiBox>
                            </Grid>
                        </Grid>
                    </FaiBox>
                </FaiBox>
            </MuiCard>

        </>
    );
}

export default Card;
